import useStyles from '../../../../../style/js-style/containers/administration/calculator/CalculatorDialogStyle';
import Variable from './Variable';
import React from 'react';
import i18next from 'i18next';
import EAColorIcon from '../../../../../components/common/EAColorIcon';

const InnerVariables = ({
                          fieldName,
                          items,
                          type,
                          onAddEntry,
                          onRemoveEntry,
                          validateName,
                          onVariableChangeCallBack,
                          readOnly = false
                        }) => {
  const { classes } = useStyles();

  return (
    <>
      {items?.map((item, index) => {
        if (item.type === type) {
          return (
            <Variable
              key={item.id}
              fieldName={`${fieldName}.${index}`}
              onRemove={() => onRemoveEntry(index)}
              validateName={validateName}
              onVariableChangeCallBack={onVariableChangeCallBack}
              readOnly={readOnly}
            />
          );
        } else {
          return (
            <React.Fragment key={item.id}></React.Fragment>
          );
        }
      })}

      {/* Add a variable */}
      {!readOnly &&
        <div
          className={classes.addVariable}
          style={{ padding: "10px", width: "180px", cursor: "pointer", display: "flex", alignItems: 'center' }}
          onClick={() => onAddEntry(type)}
        >
          <EAColorIcon icon={"add_green"} width={20} svgStyle={{ position: "relative", top: "2px" }}/>
          <span> {i18next.t("calculator.dialog.create.addVariable")}</span>
        </div>
      }
    </>
  );
}

export default InnerVariables;